export const EFT = 'DIRECT_DEPOSIT';
export const DET = 'DIRECT_DEBIT_DEPOSIT';

